import authApi from "../../api/authenticationApi";
import testAttemptsApi from "../../api/testAttemptApi";
import generalApi from "../../api/generalApi";
//import authenticationApi from "../../api/authenticationApi";

const state = {
  testAttemptId: null,
  languages: [
    { name: "English", code: "en", locale: 1033, default: true },
    { name: "Español", code: "es", locale: 2058, default: false },
  ],
  testAttempts: [],
  currentLocaleId: 1033,
  language: "en",
  fontSizeAdjustment: 0,
  uniqueId: null,
  userDetails: {
    firstName: "",
    lastName: "",
    zipCode: 0,
    birthDates: [],
    ages: [],
    examineeId: 0,
    uniqueId: null,
    photoId: 0,
  },
  authToken: {},
  screenMessages: null,
  testStage: null,
  termsAgreed: false,
};

const getters = {
  userSession(state) {
    return state;
  },
  testAttempts(state) {
    return state.testAttempts;
  },
  selectedLanguage(state) {
    return state.language;
  },
  selectedLocaleId(state) {
    const language = state.languages.find(
      (value) => value.code == state.language
    );
    return language.locale;
  },
  userDetails(state) {
    return {
      firstName: state.userDetails.firstName,
      lastName: state.userDetails.lastName,
      fullName: state.userDetails.firstName + " " + state.userDetails.lastName,
      zipCode: state.userDetails.zipCode,
      uniqueId: state.userDetails.uniqueId,
      examineeId: state.userDetails.examineeId,
      photoId: state.userDetails.photoId,
    };
  },
  officeName(state) {
    return state.testAttempts.length > 0
      ? state.testAttempts[0].location
      : "NA";
  },
  birthDates(state) {
    return state.userDetails.birthDates;
  },
  ages(state) {
    return state.userDetails.ages;
  },
  authToken(state) {
    return state.userDetails.authToken;
  },
  languages(state) {
    let languages = state.languages;
    if (state.testAttempts && state.testAttempts.length > 0) {
      const testAttempt = state.testAttempts[0];
      languages = languages.filter((l) => {
        return l.default || testAttempt.localeId === l.locale;
      });
    }
    return languages;
  },
  screenMessages(state) {
    return state.screenMessages;
  },
  testStage(state) {
    return state.testStage;
  },
  termsAgreed(state) {
    return state.termsAgreed;
  },
  uniqueId(state) {
    return state.uniqueId;
  },
  loggedIn(state) {
    return state.authToken != null;
  },
};

const mutations = {
  SET_LANGUAGE(state, language) {
    state.language = language;
  },
  SET_USER_DETAILS(state, userDetails) {
    state.userDetails.firstName = userDetails.firstName;
    state.userDetails.lastName = userDetails.lastName;
    state.userDetails.examineeId = userDetails.examineeId;
    state.userDetails.birthDates = userDetails.birthDates;
    state.userDetails.ages = userDetails.ages;
    state.userDetails.uniqueId = userDetails.token;
    state.userDetails.zipCode = userDetails.zipCode;
    state.userDetails.photoId = userDetails.localPhotoId;
  },
  SET_AUTH_TOKEN(state, authToken) {
    state.authToken = authToken;
  },
  SET_TEST_ATTEMPTS(state, testAttempts) {
    state.testAttempts = testAttempts;
  },
  SET_SCREEN_MESSAGES(state, screenMessages) {
    state.screenMessages = screenMessages;
  },
  SET_TEST_STAGE(state, testStage) {
    state.testStage = testStage;
  },
  SET_TERMS_AGREED(state, isTermsAgreed) {
    state.termsAgreed = isTermsAgreed;
  },
  SET_UNIQUE_ID(state, uniqueId) {
    state.uniqueId = uniqueId;
  },
};

/*Helper Functions*/
function setDefaultTestAttempt(commit) {
  const testAttempt = {
    testAttemptId: 0,
    testName: "",
  };
  commit("SET_TEST_ATTEMPT", testAttempt);
}

function setDefaultTestAttempts(commit) {
  const testAttempts = [];
  commit("SET_TEST_ATTEMPTS", testAttempts);
}

function setDefaultUserDetails(commit) {
  const userDetails = {
    firstName: "",
    lastName: "",
    zipCode: 0,
    examineeId: 0,
    birthDates: [],
    ages: [],
    token: "",
    photoId: 0,
  };
  commit("SET_USER_DETAILS", userDetails);
}

function clearAuthToken(commit) {
  commit("SET_AUTH_TOKEN", null);
}

function clearTestStateAndTerms(commit) {
  commit("SET_TEST_STAGE", 0);
  commit("SET_TERMS_AGREED", false);
}

const actions = {
  async getExamineeFromUniqueId({ dispatch }, token) {
    dispatch("setBusy");
    const examineeInfo = await authApi.getExamineeFromUniqueId(token);
    dispatch("clearBusy");
    return examineeInfo;
  },
  remoteLogin({ commit }, userDetails) {
    commit("SET_USER_DETAILS", userDetails);
    commit("SET_PAGE", "DateOfBirthLogin");
  },
  async verifyDOBLogin({ commit, getters, dispatch }, dobInfo) {
    console.log(dobInfo.birthDate, dobInfo.age);
    dispatch("setBusy");
    if (dobInfo.birthDate !== "" && dobInfo.age !== "") {
      try {
        let tokenInfo = null;
        console.log(getters);
        if (getters.kioskSerialNumber && getters.kioskSerialNumber !== "") {
          tokenInfo = await authApi.loginKiosk(
            dobInfo.birthDate,
            dobInfo.age,
            getters.kioskSerialNumber,
            getters.userDetails.uniqueId
          );
        } else {
          tokenInfo = await authApi.remoteLogin(
            dobInfo.birthDate,
            dobInfo.age,
            getters.userDetails.uniqueId
          );
        }

        console.log(tokenInfo);
        if (tokenInfo) {
          commit("SET_AUTH_TOKEN", tokenInfo);
        }
      } catch (error) {
        throw error.response.data;
      } finally {
        dispatch("clearBusy");
      }
    }
  },
  async setLanguage({ commit, getters, dispatch }, language) {
    commit("SET_LANGUAGE", language);

    //get screen messages based on page//
    if (getters.page.value > 3) {
      const testAttemptId =
        getters.testAttempts && getters.testAttempts.length > 0
          ? getters.testAttempts[0].testAttemptId
          : 0;
      const localeId = getters.selectedLocaleId;
      await dispatch("getScreenMessages", {
        testAttemptId: testAttemptId,
        localeId: localeId,
      });
    }
  },
  setUserDetails({ commit }, userDetails) {
    console.log("setUserDetails", userDetails);
    commit("SET_USER_DETAILS", userDetails);
  },
  async startTestingSession({ commit, getters, dispatch }) {
    //Get assigned test attempts
    //Determine where the next page should be
    console.log(commit, getters);
    dispatch("setBusy");
    try {
      const testAttempts = await testAttemptsApi.getAssignedTestAttempts(
        getters.kioskSerialNumber,
        getters.userDetails.examineeId
      );
      console.log(testAttempts);
      commit("SET_TEST_ATTEMPTS", testAttempts);
      const testAttemptId =
        testAttempts && testAttempts.length > 0
          ? testAttempts[0].testAttemptId
          : 0;
      const localeId = getters.selectedLocaleId;
      await dispatch("getScreenMessages", {
        testAttemptId: testAttemptId,
        localeId: localeId,
      });
      commit("SET_PAGE", getters.pages.TestSelection.name);
    } catch (error) {
      throw error.response.data;
    } finally {
      dispatch("clearBusy");
    }
  },
  async getScreenMessages({ commit, dispatch }, params) {
    try {
      dispatch("setBusy");
      const messages = await generalApi.getScreenMessages(
        params.testAttemptId,
        params.localeId
      );
      commit("SET_SCREEN_MESSAGES", messages);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch("clearBusy");
    }
  },
  setAuthToken({ commit }, authToken) {
    commit("SET_AUTH_TOKEN", authToken);
  },
  async finished({ dispatch }) {
    //dispatch("SetPage", getters.pages.KioskLanding.name);
    dispatch("clearSession");
    dispatch("setBusy");
    await authApi.logout();
    window.location.reload();
  },
  setTestStage({ commit }, testStage) {
    commit("SET_TEST_STAGE", testStage);
  },
  setTermsAgreed({ commit }, isTermsAgreed) {
    commit("SET_TERMS_AGREED", isTermsAgreed);
  },
  setUniqueId({ commit }, uniqueId) {
    commit("SET_UNIQUE_ID", uniqueId);
  },
  clearSession({ commit, dispatch }) {
    dispatch("setBusy");
    setDefaultTestAttempt(commit);
    setDefaultTestAttempts(commit);
    setDefaultUserDetails(commit);
    clearAuthToken(commit);
    clearTestStateAndTerms(commit);
    dispatch("clearBusy");
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
